// 随机箱格-选择箱格大小
<template>
  <div class="officeLockerSelectCell">
    <step index="1"></step>
    <ul class="cell-list" :class="['cell' + box_list.length]">
      <li class="li" v-for="(item, index) in box_list" :key="index" @click="selectCellSize(item)">
        <p class="left">{{item.box_type}}</p>
        <p class="right">剩余：{{item.box_num}}</p>
      </li>
    </ul>
    <el-button type="info" class="btn noUserLoginBtn" @click="lastStep">上一步</el-button>
  </div>
</template>

<script>
  import step from './module/step.vue'
  import { showToast } from '../../../../static/turnoverCabinet/js/utility';
  var vm 

  export default{
    name: 'officeLockerSelectCell',
    components: {
      step
    },
    data () {
      return {
        box_list: []
      }
    },
    created (){
      vm = this
    },
    mounted(){
      this.getBoxList()
    },
    methods: {
      // 上一步
      lastStep () {
        this.$router.go(-1)
      },
      // 获取箱格信息
      getBoxList() {
        let box_list = [...vm.$store.state.officeLocker_deviceInfo.box_list]
        for (let i in box_list) {
          let box_size = box_list[i].box_size
          box_list[i].box_type = box_size === 'A' ? '极大' :
                                box_size === 'B' ? '大' :
                                box_size === 'C' ? '中' :
                                box_size === 'D' ? '小' : '极小'
        }
        vm.box_list = box_list
      },
      // 选择箱格大小
      selectCellSize (item) {
        if (item.box_num == 0) { 
          showToast('暂无' + item.box_type + '箱格可租用')
          return
        }
        vm.$store.state.officeLocker_randomSize = item.box_size
        vm.$store.state.officeLocker_stepInfo = { index: 2, step: 3}  //设置step
        vm.$router.push({path: '/officeLocker/login'})
      }
    }
  }
</script>

<style lang="less">
  .officeLockerSelectCell {
    height: 100vh;
    box-sizing: border-box;
    padding: 0.9rem 0 0;
    .cell-list {
      width: 15.7rem;
      margin: 1.4rem auto 0;
      display: flex;
        flex-wrap: wrap;
      .li {
        width: 4.57rem;
        height: 1.82rem;
        line-height: 1.82rem;
        padding: 0 0.5rem;
        margin-right: 0.9rem;
        margin-bottom: 0.8rem;
        border-radius: 0.1rem;
        color: #ffffff;
        box-shadow: #2c4b64 0px 0px 0.2rem;
        display: flex;
        justify-content: space-between;
        background: -webkit-linear-gradient(to top ,#0669be, #4cacff); /* Safari 5.1 - 6.0 */
        background: -o-linear-gradient(to top,#0669be, #4cacff); /* Opera 11.1 - 12.0 */
        background: -moz-linear-gradient(to top,#0669be, #4cacff); /* Firefox 3.6 - 15 */
        background: linear-gradient(to top,#0669be, #4cacff);
        .left{
          font-size: 0.66rem;
          font-weight: bold;
        }
        .right{
          font-size: 0.35rem;
        }
      }
      .li:nth-child(1){
        background: -webkit-linear-gradient(to top ,#076abf, #4cacff); /* Safari 5.1 - 6.0 */
        background: -o-linear-gradient(to top,#076abf, #4cacff); /* Opera 11.1 - 12.0 */
        background: -moz-linear-gradient(to top,#076abf, #4cacff); /* Firefox 3.6 - 15 */
        background: linear-gradient(to top,#076abf, #4cacff);
      }
    }
    .cell-list.cell2{
      .li:nth-child(1){
        margin-left: 2.75rem;
      }
    }
    .cell-list.cell3{
      .li:nth-child(3){
        margin-right: 0;
      }
    }
    .cell-list.cell4{
      .li:nth-child(odd){
        margin-left: 2.75rem;
      }
      .li:nth-child(even){
        margin-right: 2.75rem;
      }
    }
    .cell-list.cell5{
      .li:nth-child(1){
        margin-left: 2.75rem;
      }
      .li:nth-child(2){
        margin-right: 2.75rem;
      }
      .li:nth-child(5){
        margin-right: 0;
      }
    }
    .btn{
      height: 0.94rem;
      width: 2.54rem;
      padding: 0;
      font-size: 0.4rem;
      color: #fff;
      font-weight: bold;
      border: none;
      border-radius: 0.12rem;
      line-height:0.94rem;
      background: linear-gradient(#4aaafe, #0769be);
    }
    .btn.noUserLoginBtn{
      position: absolute;
      right: 0.5rem;
      bottom: 1rem;
      z-index: 99;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/officeLocker/page/selectCell.vue